import { useTheme } from '@mui/material/styles'

const Translations = ({ text, isStyleInUse }) => {
  const theme = useTheme()

  return <span style={isStyleInUse ? { fontSize: theme.typography.body2.fontSize } : { fontSize: theme.typography.body1.fontSize }}>{text}</span>;
}

export default Translations
